import ValidationHelper from "../../utilities/ValidationHelper";
import { evaluateRules } from "../../utilities/PasswordValidation";

export const validateEmail = (email) => {
    let error = null;
    if (ValidationHelper.isNullOrEmpty(email))
        error = "Required field.";
    else if (!ValidationHelper.isValidEmailFormat(email))
        error = "Please enter a valid email address.";
    return ValidationHelper.createValidationResult(error === null, error);
};

export const requiredValue = (value) => {
    let error = null;
    if (ValidationHelper.isNullOrEmpty(value))
        error = "Required field.";
    return ValidationHelper.createValidationResult(error === null, error);
};

export const passwordValidation = (password, settings, passwordValidationUserData = null) => {
    let error = null;
    if (ValidationHelper.isNullOrEmpty(password))
        error = "Required field.";
    else if (settings && evaluateRules(settings, password, password, null, passwordValidationUserData).allowConfirmPassword == false)
    {
        error = "Password does not meet minimum requirements.";
    }
    return ValidationHelper.createValidationResult(error === null, error);
};

export const passwordsMatch = (password, repeatPassword) => {
    let error = null;
    if (password != repeatPassword)
        error = "Passwords do not match.";
    return ValidationHelper.createValidationResult(error === null, error);
};

export const pinValidation = (pin) => {
    let error = null;
    if(!ValidationHelper.isDigitsOnly(pin))
        error = "PIN should consist of digits.";
    if (ValidationHelper.isNullOrEmpty(pin))
        error = "Required field.";
    if (pin.length < 4)
        error = "PIN should be 4 or more digits.";
    if (pin.length > 10)
        error = "PIN should be 10 or less digits.";
    return ValidationHelper.createValidationResult(error === null, error);
};

